export class DateTimeFormat {
  static readonly DATE_FMT = 'DD/MM/YYYY';
  static readonly DATE_TIME_FMT = `${DateTimeFormat.DATE_FMT} hh:mm:ss`;
}
